import { BaseContract, USDC_DECIMALS } from './common/base.contract';
import {Contract, ethers, formatUnits, JsonRpcProvider, parseEther, parseUnits} from 'ethers';
import { toNumber } from './common/base-cdk-contract';
import USDCAbi from '../abi/USDC.json';
import { IERC20 } from '../model/erc20.model';
import { formatUsdc, parseUsdc } from '../utils/web3-convert.utils';
import { log } from 'console';

export class USDC extends BaseContract implements IERC20 {
    constructor(address: string, provider: JsonRpcProvider) {
        super(new Contract(address, USDCAbi.abi, provider));
    }

    name = async (): Promise<string> => {
        return await this.contract.name();
    }

    symbol = async (): Promise<string> => {
        return await this.contract.symbol();
    }

    decimals = async (): Promise<number> => {
        return await this.contract.decimals();
    }

    totalSupply = async (): Promise<number> => {
        const supply = await this.contract.totalSupply();
        return toNumber(supply);
    }

    balanceOf = async (account: string): Promise<number> => {
        const balance = await this.contract.balanceOf(account);
        return formatUsdc(balance);
    }

    allowance = async (owner: string, spender: string): Promise<number> => {
        const allowed = await this.contract.allowance(owner, spender);
        return toNumber(allowed);
    }

    // Méthodes d'écriture avec parseUnits
    approve = async (spender: string, amount: number) => {
        const contractWithSigner = await this._getSignedContract();
        const tx = await contractWithSigner.approve(spender, ethers.parseUnits(amount.toString(), 6));
        await tx.wait();
    }

    transfer = async (recipient: string, amount: number) => {
        const contractWithSigner = await this._getSignedContract();
        const tx = await contractWithSigner.transfer(recipient, parseUsdc(amount.toString()));
        await tx.wait();
    }

    transferFrom = async (sender: string, recipient: string, amount: number) => {
        const contractWithSigner = await this._getSignedContract();
        const tx = await contractWithSigner.transferFrom(
            sender, 
            recipient, 
            parseUsdc(amount.toString())
        );
        await tx.wait();
    }


    //TODO: REMOVE and use USDC Faucet!!
    receiveUsdcFromFaucet = async (userAddress: string, amount: number) => {
        const contractWithSigner = (await this._getSignedContract()) as any;
        const tx = await contractWithSigner.faucet(userAddress, amount);
        await tx.wait();
    };

} 
